import api from "@/common/js/api";
import tenderBeian from "@/common/js/tenderBeian";
import { createStore } from "vuex";
import { getUrlParams } from "@/common/js/utils";

import request from "./request";
import registration from "../../common/js/registration";

import reportToCTBA from "./modules/reportToCTBA";
import reportToProvince from "./modules/reportToProvince";
import electronicMail from "./modules/electronicMail";
import waterStore from "./modules/waterStore";
import houseStore from "./modules/houseStore";
import dateStore from "./modules/date"
import { ElMessageBox } from "element-plus";

import { customRule } from "@/common/tender/customRule";
import { customHooks } from "@/common/tender/customHooks";
import { houseRules } from "@/common/tender/house/rules";
import { houseHooks } from "@/common/tender/house/hooks";

const _global = {
  config: null,
  sysCode: {
    house: 1,
    water: 2,
    traffic: 3
  }
};

export const setGlobalConfig = (config, isTemplate) => {
  _global.config = config;
  isTemplate || request.reSetParams();
};

export default createStore({
  state: {
    sysCode: _global.sysCode[__type__] || 1,
    validTv: null,
    $vm: null,
    config: null,
    ready: false,
    loading: true,
    needDJ: false, // 是否需要入场登记
    isEdit: false,
    isPublic: false,
    isTemplate: false,
    isHasGuarantee: false,
    category: "工程建设",
    id: "",
    statusList: [],
    form: {
      regionId: "",
      PLATE_FORM_OPTIONS: {},
    },
    count: {
      success: 0,
      total: 0,
      chapters: [],
    },
    actionSetting: {
      form: true,
      commit: true,
      sign: true,
      append: null,
      prepend: null,
    },
    signUrlOptions: {
      result: false,
      json: {},
    },
    openSignConfig: {
      step_1: "请点击我打开签章程序。支持深圳cA",
      switch_text: "福建省统一CA点我签章（瑞术、凯特、恒瑞通、首众）",
    },
    modules: {
      electronicMail: false,
      reportToCTBA: false,
      reportToProvince: false,
      prepend: null,
      append: null,
    },
    commitAction: null,
    actions: [],
    records: [],
    chapterComponents: {},
    reloadActions: 0,
    validatorCount: 0,
    scrollToId: "",
    fileServer: "https://upload.qiniup.com",
    tenderMenuOn: "tender-section-0-0",
    selections: {
      AlipayAccounts: [
        {
          Name: "",
          Value: "",
        },
      ],
      bankOptions: [],
      bookingOptions: [],
    },
    areas: [],
    isGettingAreasOrGotten: false, 
    formItems: {}
  },
  getters: {
    chapters(state, getters) {
      let { config } = state;
      let { isInvited } = getters;
      if (config) {
        config.Chapters.forEach((chapter) => {
          if (isInvited && chapter.IsTenderFile) chapter.Title = chapter.Title.replace(/^招标公告|招标文件$/, "投标邀请书");
          chapter.Sections.forEach((section) => {
            if (isInvited && section.IsTenderFile) section.Title = section.Title.replace(/^招标公告|招标文件$/, "投标邀请书");
          });
        });
        return config.Chapters;
      } else {
        return null;
      }
    },
    properties(state) {
      if (state.config) {
        return state.config.Properties;
      } else {
        return null;
      }
    },
    isInvited(state) {
      return state.form.way === "邀请招标";
    },
    isEdit(state) {
      return !!state.commitAction;
    },
    actionsLength(state) {
      return state.actions.length
    },
    isOutSite(state) {
      return state.form.regionId && state.form.regionId.indexOf("x") === 0;
    },
    TECHNICAL_DOCUMENTS_REQUIRE(state) {
      return state.form.TECHNICAL_DOCUMENTS_REQUIRE === "要求";
    },
    PlateFormName(state) {
      let {regionId, PLATE_FORM_OPTIONS} = state.form || {}
      return regionId === `x60004` ? `福建省国资采购平台` : `${PLATE_FORM_OPTIONS.type}电子招标投标交易平台`
    },
    PlateFormNameWithUrl(state) {
      let { regionId, PLATE_FORM_OPTIONS } = state.form || {}
      if(PLATE_FORM_OPTIONS) {
        return regionId === 'x60004' ? `福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）` : 
                                       `${ PLATE_FORM_OPTIONS.type === "易交易" ? "随行易交易" : PLATE_FORM_OPTIONS.type }电子招标投标交易平台${ PLATE_FORM_OPTIONS.web }`
      } else {
        return ''
      }
    }
  },
  mutations: {
    setModules(state, config) {
      state.modules = config;
    },
    setIsGettingAreasOrGotten (state, isGettingAreasOrGotten) {
      state.isGettingAreasOrGotten = isGettingAreasOrGotten;
    },
    setActionSetting (state, { prepend, append }) {
      state.actionSetting.prepend = prepend;
      state.actionSetting.append = append;
    },
    setVm (state, vm) {
      state.$vm = vm;
    },
    setConfig (state, config) {
      state.config = config;
    },
    setReady (state, ready) {
      state.ready = ready;
    },
    setIsEdit (state, isEdit) {
      state.isEdit = isEdit;
    },
    setIsHasGuarantee (state, isHasGuarantee) {
      state.isHasGuarantee = isHasGuarantee;
    },
    setPublic (state, isPublic) {
      state.isPublic = isPublic;
    },
    setIsTemplate (state, isTemplate) {
      state.isTemplate = isTemplate;
    },
    setLoading (state, loading) {
      state.loading = loading;
    },
    setId (state, id) {
      state.id = id;
    },
    setStatusList (state, statusList) {
      state.statusList = statusList
    },
    setForm (state, form) {
      state.form = form;
    },
    setCount (state, count) {
      state.count = count;
    },
    setCommitAction (state, commitAction) {
      state.commitAction = commitAction;
    },
    setActions (state, actions = []) {
      state.actions = actions;
    },
    setReloadActions (state) {
      state.reloadActions++;
    },
    setOpenSignConfig (state, openSignConfig) {
      state.openSignConfig = openSignConfig;
    },
    setSignUrlOptions (state, signUrlOptions) {
      state.signUrlOptions = signUrlOptions;
    },
    setRecords (state, records) {
      state.records = records;
    },
    setChapterComponents (state, chapterComponents) {
      state.chapterComponents = chapterComponents;
    },
    setValidatorCount (state, count) {
      state.validatorCount = count;
    },
    setScrollToId (state, id) {
      state.scrollToId = id;
    },
    setTenderMenuOn (state, on) {
      state.tenderMenuOn = on;
    },
    setFormItemValue (state, { key, value }) {
      state.form[key] = value;
    },
    setAlipayAccounts (state, accounts) {
      state.selections.AlipayAccounts = accounts;
    },
    setGclqdOptions (state, options) {
      state.selections.gclqdOptions =
        options &&
        options.map((item) => {
          item.Name = item.name;
          item.Value = item.name;
          return item;
        });
    },
    setBankOptions (state, options) {
      state.selections.bankOptions =
        options &&
        options.map((item) => {
          item.Name = item.NAME;
          item.Value = item.NAME;
          return item;
        });
    },
    setBookingOptions (state, options) {
      state.selections.bookingOptions = options;
    },
    setNeedDJ (state, needDJ) {
      state.needDJ = needDJ;
    },
    setFormItems (state, config) {
      state.formItems = config.FormItems || {}
    }
  },
  actions: {
    ajaxAutoItems (state, OptionsUrl) {
      return new Promise((resolve, reject) => {
        api
          .get(OptionsUrl)
          .then((res) => {
            if (res.result) {
              let str = "?" + OptionsUrl.split("?")[1];
              console.log(getUrlParams(str).key);
              let key = getUrlParams(str).key;

              let list = res.json.map((item) => {
                item.Value = item[key];
                return item;
              });
              resolve(list);
            } else {
              resolve([]);
            }
          })
          .catch((e) => null);
      });
    },
    initAreas({ state }) {
      return request.getAreaTree().then((json) => {
        state.areas = json.allAreaTree;
      });
    },
    setFormItemWithCustom({ state, getters }, { type, obj, autocompleteObject, args }) {
      customHooks(type, obj, args, state.form, getters.properties, autocompleteObject);
    },
    houseHooks({ state, getters }, { type, obj, args }) {
      houseHooks(type, obj, args, state.form, getters.properties, state);
    },
    setCustomValidate({ state }, { obj, args, value, callback }) {
      customRule(obj, args, value, callback, state.form);
    },
    houseRules({ state }, { obj, args, value, callback, noisy }) {
      houseRules(obj, args, value, callback, state.form, noisy);
    },
    requestConfig ({ state }) {
      return new Promise((resolve, reject) => {
        resolve(_global.config);
      });
    },
    requestActions ({ state }) {
      return request.getActions();
    },
    requestNextActions ({ state }, tag) {
      return request.getNextActions(tag);
    },
    requestRegSections ($store, param) {
      return request.getSections(param);
    },
    requestRegSectionDetail ($store, param) {
      return request.getRegSectionDetail(param);
    },
    transRegInfoToTheForm ({ state, commit, dispatch }, REGISTRATION) {
      registration.setRegInfoToTheForm(state.form, REGISTRATION);
      dispatch("setValidatorCount");
      state.$vm.$alert("操作成功", "操作提示", { type: "success" });
      commit("setScrollToId", "tender-section-0-2");
    },
    initPublicActions ({ state }) {
      return request.getPublicActions(state.form, state.isHasGuarantee, state.statusList);
    },
    requestDataExchange ({ state }) {
      return request.getDataExchange();
    },
    requestRecords ({ state }, obj) {
      let { url } = obj.actionContent;
      return request.getRecords(url);
    },
    requestTenderProject ($store) {
      return request.getTenderProject($store);
    },
    requestOpenSignConfig ({ commit }) {
      return request.getOpenSignConfig().then((config) => {
        commit("setOpenSignConfig", config);
      });
    },
    requestFileToken ({ state }, raw) {
      return request.getFileToken(raw);
    },
    initAlipayAccounts ($store, call) {
      request.getAlipayAccounts().then((accounts) => {
        accounts.forEach((acc) => {
          acc.Name = acc.Value = acc.account;
          acc.RealName = acc.realname
        });
        $store.commit("setAlipayAccounts", accounts);
        call && call()
      });
    },
    initBankOptions ($store) {
      request.getBankList($store.state.form).then((res) => {
        $store.commit("setBankOptions", res);
      });
    },
    initBookingOptions ($store) {
      request.getBookingOptions($store.state.form).then((res) => {
        $store.commit("setBookingOptions", res);
      });
    },
    setEntpBaseInfo ({ state }) {
      return request.setEntpBaseInfo(state.form, state.$vm);
    },
    setTenderCountByIndex ({ state }, { chapterIndex, sectionIndex, total, fail }) {
      let { count } = state;
      let section = count.chapters[chapterIndex].sections[sectionIndex];
      section.total = total;
      section.success = total - fail;
    },
    calcTenderCount ({ state }) {
      let { count } = state;
      let success = 0;
      let total = 0;
      count.chapters.forEach((chapter) => {
        let _success = 0;
        let _total = 0;
        chapter.sections.forEach((section) => {
          _success += section.success;
          _total += section.total;
        });
        chapter.success = _success;
        chapter.total = _total;
        success += _success;
        total += _total;
      });
      count.success = success;
      count.total = total;
    },
    doAction ($store, obj) {
      let { form } = $store.state;
      if (__type__ !== "water") {
        if (form.TENDER_PROJECT_NAME === undefined) {
          form.TENDER_PROJECT_NAME = form.PROJECT_NAME;
        }
        if (form.PROJECT_NAME === undefined) {
          form.PROJECT_NAME = form.TENDER_PROJECT_NAME;
        }
      }

      request.doSwitch(obj, form, $store);
    },
    doSaveTemp ($store, { obj, form, call }) {
      if (__type__ == "water") {
        request.doCommitWater($store, obj, form, call);
      } else {
        request.doCommit($store, obj, form, call);
      }
    },
    doValid ({ state }) {
      return state.$vm.validate();
    },
    doGet ({ state }, url, obj) {
      return api.get(url, obj);
    },
    doPost ({ state }, { url, data }) {
      return api.form(url, data);
    },
    setValidatorCount ({ state, commit }) {
      commit("setValidatorCount", state.validatorCount + 1);
    },
    setScrollToId ({ commit }, id) {
      commit("setScrollToId", id);
      commit("setTenderMenuOn", id);
    },
    jumpToLogin ({ state }) {
      let { regionId } = state.form;
      let { name } = getUrlParams(window.top.location.search);
      if (name === "logOn_Phone_Gong") {
        window.open("http://oauth.xmzfcg.com/Account/logOn_Phone_Gong?code=logOn_Phone_Gong");
      } else if (name === "LogOn_GUOZI") {
        window.open("https://usercenter.enjoy5191.com/index.html#/login?code=LogOn_GUOZI");
      } else if (name === "logOn_XIAMENAIR" || regionId === "x50002") {
        window.open("https://usercenter.enjoy5191.com/index.html#/login?code=logOn_XIAMENAIR");
      } else if (name === "LogOn_Phone_LYS") {
        window.open("https://usercenter.enjoy5191.com/index.html#/login?code=LogOn_Phone_LYS");
      } else if (name) {
        window.open(`https://usercenter.enjoy5191.com/index.html#/login?code=${name}`)
      } else {
        window.open("https://usercenter.enjoy5191.com/");
      }
    },
    setBaOrBjData ({ state, commit }, { param, options }) {
      let { form } = state;
      let { Key, Name } = options;
      if (form[Key]) {
        request.getBaOrBjData(param.url, form, form[Key], Name).then((res) => {
          if (Key === "REPORT_NUMBER") {
            tenderBeian.setBjData(form, res);
          }
          if (Key === "RECORD_NUMBER") {
            tenderBeian.setBaData(form, res, () => {
              clearTimeout(state.validTv);
              state.validTv = setTimeout(() => {
                commit("setValidatorCount", state.validatorCount + 1);
              }, 500);
            });
          }
        });
      } else {
        ElMessageBox.alert(`请先填写${options.Name}`, "提示", {
          type: "error",
        });
      }
    },
  },
  modules: {
    reportToCTBA,
    reportToProvince,
    electronicMail,
    waterStore,
    houseStore,
    dateStore
  },
});
